import { useTheme } from "../OAS365Theme";

export const useCloseIconStyle = () => {
  const theme = useTheme();
  const CloseIconStyle = {
    CloseIconButtonStyle: closeIcon(theme),
  };
  return CloseIconStyle;
};

const closeIcon = (theme) => {
  const style = {
    background: "transparent",
    border: "transparent",
    cursor: "pointer",
    color: theme.colors.themeDarkColor,
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.menusize,
    fontWeight: theme.fontWeight.menuWeight,
    root: {
      ".ms-Button-icon": {
        fontSize: theme.fontSizes.menusize,
        color: theme.colors.themeDarkColor,
        fontFamily: theme.fonts.regular,
      },
      ".ms-StackItem": {
        fontSize: theme.fontSizes.menusize,
        color: theme.colors.themeDarkColor,
        fontFamily: theme.fonts.regular,
      },
    },
    rootHovered: {
      background: "transparent",
      fontFamily: theme.fonts.regular,
    },
  };
  return style;
};
